import PropTypes from 'prop-types';
import React from 'react';

import { Media } from '$partials/media';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const ModuleLargeMediaBlock = ({
    media = null
}) => {
    // render
    return (
        <div className='layout-container relative my-40 md:my-60'>
            <div className='layout-grid-negative-gutter'>
                <div className='sm:flex'>
                    <div className='md:w-1/12' />

                    <div className='w-12/12 md:w-11/12 layout-grid-col-padding'>
                        <figure>
                            <Media { ...media } />

                            {media?.caption && (
                                <figcaption className='type-style-4 pt-20'>
                                    {media.caption}
                                </figcaption>
                            )}
                        </figure>
                    </div>
                </div>
            </div>

        </div>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    media: PropTypes.object.isRequired
};

ModuleLargeMediaBlock.propTypes = propTypes;

export default ModuleLargeMediaBlock;
